import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { endingMessages } from '../data/content';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiInstagram, FiFacebook, FiAtSign, FiHeart } = FiIcons;

export default function DonePage({ category, onReset, onAbout }) {
  const [message, setMessage] = useState(null);
  const [releaseDate, setReleaseDate] = useState('');
  const [releaseTime, setReleaseTime] = useState('');

  useEffect(() => {
    const categoryId = category?.id || 'other';
    const messages = endingMessages[categoryId];
    const randomIndex = Math.floor(Math.random() * messages.length);
    setMessage(messages[randomIndex]);

    const now = new Date();
    const dateStr = `${now.getFullYear()} . ${(now.getMonth() + 1).toString().padStart(2, '0')} . ${now.getDate().toString().padStart(2, '0')}`;
    const timeStr = `${now.getHours().toString().padStart(2, '0')} : ${now.getMinutes().toString().padStart(2, '0')}`;
    setReleaseDate(dateStr);
    setReleaseTime(timeStr);
  }, [category]);

  if (!message) return null;

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: "easeInOut" }}
      className="relative z-10 w-full h-full flex flex-col bg-[#12181C] px-6 py-6 md:py-10"
    >
      <div className="flex-1 w-full overflow-y-auto no-scrollbar flex flex-col">
        <div className="m-auto flex flex-col items-center justify-center w-full max-w-2xl text-center py-8">
          
          <div className="space-y-10 px-4 flex flex-col items-center w-full">
            <motion.div 
              initial={{ y: 20, filter: 'blur(8px)', opacity: 0 }}
              animate={{ y: 0, filter: 'blur(0px)', opacity: 1 }}
              transition={{ duration: 2, delay: 0.5, ease: "easeOut" }}
            >
              <h2 className="font-brush text-[#E8EDF2] text-5xl md:text-6xl tracking-widest leading-relaxed">
                {message.title}
              </h2>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 2, delay: 2.5 }}
            >
              <p className="font-handwriting text-[#8C96A0] text-lg md:text-xl tracking-[0.2em] whitespace-pre-wrap leading-loose">
                {message.subtitle}
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 2, delay: 4.5 }}
              className="flex flex-col items-center mt-8 space-y-3"
            >
              <p className="font-handwriting text-[#8C96A0]/40 text-xs md:text-sm tracking-[0.3em]">
                {releaseDate}
              </p>
              <p className="font-handwriting text-[#8C96A0]/70 text-sm md:text-base tracking-[0.2em]">
                於 {releaseTime} 隨湖水遠去
              </p>
            </motion.div>
          </div>

          <motion.button
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1.5, delay: 6.0 }}
            onClick={onReset}
            className="px-8 md:px-10 py-3 rounded-full border border-[#8C96A0]/30 text-[#8C96A0] text-sm md:text-base font-handwriting tracking-widest transition-all duration-500 hover:bg-[#E8EDF2]/10 hover:text-[#E8EDF2] hover:border-[#E8EDF2]/50 active:scale-95 mt-10 md:mt-12"
          >
            深呼吸，回到日常
          </motion.button>
        </div>
      </div>

      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5, delay: 6.5 }}
        className="shrink-0 pt-4 pb-2 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-[#8C96A0]/40 w-full"
      >
        <a href="https://www.instagram.com/homy.hk" target="_blank" rel="noopener noreferrer" className="p-2 hover:text-[#E8EDF2] transition-all duration-500 hover:-translate-y-1">
          <SafeIcon icon={FiInstagram} className="w-[1.125rem] h-[1.125rem]" />
        </a>
        <a href="https://www.facebook.com/profile.php?id=61578745554661" target="_blank" rel="noopener noreferrer" className="p-2 hover:text-[#E8EDF2] transition-all duration-500 hover:-translate-y-1">
          <SafeIcon icon={FiFacebook} className="w-[1.125rem] h-[1.125rem]" />
        </a>
        <a href="https://www.threads.com/@homy.hk" target="_blank" rel="noopener noreferrer" className="p-2 hover:text-[#E8EDF2] transition-all duration-500 hover:-translate-y-1 flex items-center gap-1.5 font-handwriting tracking-widest text-sm">
          <SafeIcon icon={FiAtSign} className="w-4 h-4" /> 
          Threads
        </a>
        <div className="w-[1px] h-3 bg-[#8C96A0]/30 hidden md:block"></div>
        {/* 帶參數 'support'，讓 AboutPage 知道要自動捲動 */}
        <button onClick={() => onAbout('support')} className="p-2 hover:text-white transition-all duration-500 hover:-translate-y-1 flex items-center gap-1.5 font-handwriting tracking-widest text-sm text-[#8C96A0]/60">
          <SafeIcon icon={FiHeart} className="w-4 h-4" /> 
          支持我們
        </button>
      </motion.div>
    </motion.div>
  );
}